import { Container, Row } from "reactstrap";
import BrowseArticles from "./BrowseArticles";
import KnowledgeSearch from "./KnowledgeSearch";
import { LatestArticlesVideosknowledge } from "../../../Data/Miscellaneous/FAQ";
import FaqWidgets from "../FAQ/FaqWidgets";
import FeaturedTutorials from "../FAQ/FeaturedTutorials";
import LatestArticlesVideos from "../FAQ/LatestArticlesVideos";
import { Breadcrumbs } from "../../../AbstractElements";
import { KnowledgebaseTitle } from "../../../Constants/Constants";

const KnowledgebaseContainer = () => {
  return (
    <>
    <Breadcrumbs mainTitle={KnowledgebaseTitle} parent={KnowledgebaseTitle} />
    <Container fluid>
      <Row>
        <KnowledgeSearch />
        <FaqWidgets />
        <BrowseArticles />
        <FeaturedTutorials />
        <LatestArticlesVideos titleClass="f-w-600" rowClass="latest-articles" divClass="articles-icons" data={LatestArticlesVideosknowledge} />
      </Row>
    </Container>
    </>
  );
};
export default KnowledgebaseContainer;
